<app-button [buttonText]="buttonTitle" iconUrl="assets/icons/filter_list.svg" (onButtonClick)="toggleDropdown()"
  [clicked]="_dropdownOpened" [updateButtonStyle]="_updateButtonStyle()"></app-button>